<div id="new_issue">
  <div class="editrow">
    <ng-container *ngIf="!inHub; else sourcelabel">
      <mat-form-field id="issue_hubid">
        <input #hubid matInput required placeholder="Hub ID" [(ngModel)]="issue.hubid" />
      </mat-form-field>
    </ng-container>
    <ng-template #sourcelabel>
      <span class="hubid">{{issue.hubid}}</span>
    </ng-template>
    <mat-form-field class="priority_select">
      <mat-select placeholder="Priority" #issue_priority required [(ngModel)]="issue.priority" name="priority">
        <mat-option *ngFor="let priority of issue_priorities" [value]="priority.id">{{priority.description}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="source_select">
      <mat-select #issue_source placeholder="Source" required [(ngModel)]="issue.source" name="source">
        <mat-option *ngFor="let source of issue_sources" [value]="source.issue_source_id">{{source.issue_source_text}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="status_select">
      <mat-select #issue_status placeholder="Status" required [(ngModel)]="issue.status" name="status">
        <mat-option *ngFor="let status of issue_statuses" [value]="status.issue_status_id">{{status.issue_status_text}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="general_select">
      <mat-select (selectionChange)="reset()" placeholder="Type" [(ngModel)]="newIssueTag.issue_tag_type_id">
        <mat-option *ngFor="let type of issueTagTypeList" [value]="type.issue_tag_type_id">{{type.issue_tag_type_name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <ng-container *ngIf="newIssueTag.issue_tag_type_id!=null; then isGeneral; else isEmpty"></ng-container>
  </div>
  <div class="editrow">
    <mat-form-field class="action_select">
      <mat-select #issue_status placeholder="Action" required [(ngModel)]="issue.issue_action_id">
        <mat-option *ngFor="let action of issueTagActionList" [value]="action.issue_action_id">
          {{action.issue_action_name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="followup_select">
      <mat-select placeholder="Follow Up Required?" [(ngModel)]="issue.customer_followup">
        <mat-option [value]="true">Yes</mat-option>
        <mat-option [value]="false">No</mat-option>
      </mat-select>
    </mat-form-field>
    <div>
      <div class="editrow">
        <mat-form-field id="issue_title">
          <textarea matInput [(ngModel)]="issue.title" placeholder="A description of the issue" rows="4"></textarea>
        </mat-form-field>
        <div class="panel">
          <button mat-raised-button (click)="cancel()">Cancel</button>
          <button mat-raised-button color="primary" (click)="save()" [disabled]="!isValid()">Save</button>
        </div>
      </div>
      <div class="editrow">
        <span class="error">{{errorMessage}}</span>
      </div>
    </div>
  </div>
</div>
<ng-template #isGeneral>
  <mat-form-field class="general_select">
    <mat-select placeholder="Tag" [(ngModel)]="issue.issue_tag_id">
      <ng-container *ngFor="let tag of issueTagList">
        <mat-option *ngIf="tag.issue_tag_type_id==newIssueTag.issue_tag_type_id" [value]="tag.issue_tag_id">
          {{ tag.issue_tag_name }}
        </mat-option>
      </ng-container>
    </mat-select>
  </mat-form-field>
</ng-template>

<ng-template #isEmpty></ng-template>
